import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { jwtDecode } from 'jwt-decode';
import { CartService } from '../services/cart.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent {
  username = '';
  email = '';
  password = '';
  message = '';
  error = '';

  constructor(private auth: AuthService, private router: Router, private cartService: CartService) { }

  onRegister(): void {
    this.message = '';
    this.error = '';
    this.auth.register({ username: this.username, email: this.email, password: this.password }).subscribe({
      next: (res) => {
        localStorage.setItem('token', res.token);

        const decodedToken: any = jwtDecode(res.token);
        localStorage.setItem('userId', decodedToken?.userId); // or whatever field carries the userId
        const currentTime = Math.floor(Date.now() / 1000);
        //If token expired
        if (decodedToken.exp < currentTime) {
          // Redirect to login if unauthorized
          this.auth.logout();
          /*          this.router.navigate(['/login']);*/
        }
        else {
          this.cartService.refreshCartCount();
        }
        this.router.navigate(['/']); // go to home
        //this.message = 'Registration successful. You can now log in.';
        //setTimeout(() => this.router.navigate(['/login']), 1500);
      },
      error: (err) => {
        this.error = err?.error || 'Registration failed';
      }
    });
  }
}
